import type { UUID } from '@/types/common'
import type {
  CreateWarehouseArticleRequest,
  CreateWarehouseInstallationRequest,
  UpdateWarehouseArticleRequest,
  WarehouseArticle,
  WarehouseArticlesResponse,
  WarehouseHistoryResponse,
  WarehouseImportResult,
  WarehouseInstallation,
  WarehouseInstallationsResponse,
  WarehouseStateResponse,
} from '@/types/warehouse'

import { api } from './client'

export interface GetWarehouseArticlesParams {
  name?: string;
  page?: number;
  limit?: number;
  sort?: string;
}

export interface GetWarehouseInstallationsParams {
  vehicle_number?: string;
  page?: number;
  limit?: number;
}

export const warehouseApi = {
  getWarehouseState: () =>
    api.get<WarehouseStateResponse>('/warehouse'),

  createWarehouseArticle: (data: CreateWarehouseArticleRequest) =>
    api.post<WarehouseArticle>('/warehouse', data),

  importWarehouseArticles: (formData: FormData, forceUpload?: boolean) =>
    api.post<WarehouseImportResult>('/warehouse/import', formData, { params: { forceUpload } }),

  getWarehouseArticles: (params?: GetWarehouseArticlesParams) =>
    api.get<WarehouseArticlesResponse>('/warehouse/articles', params),

  updateWarehouseArticle: (id: UUID, data: UpdateWarehouseArticleRequest) =>
    api.put<WarehouseArticle>(`/warehouse/articles/${id}`, data),

  deleteWarehouseArticle: (id: UUID) =>
    api.delete<void>(`/warehouse/articles/${id}`),

  getWarehouseInstallations: (params?: GetWarehouseInstallationsParams) =>
    api.get<WarehouseInstallationsResponse>('/warehouse/installations', params),

  createWarehouseInstallation: (data: CreateWarehouseInstallationRequest) =>
    api.post<WarehouseInstallation>('/warehouse/installations', data),

  deleteWarehouseInstallation: (id: UUID) =>
    api.delete<void>(`/warehouse/installations/${id}`),

  getWarehouseHistory: () =>
    api.get<WarehouseHistoryResponse>('/warehouse/history'),
}
